const utils = require('../../lib/smugmug')
const axios = require('axios')

export default function install (Vue, options) {
  /**
   * Install SmugMug utilities and add custom methods here
   */
  Vue.prototype.$smugmug = {
    getHeight: utils.getHeight,
    resolveTemplate: utils.resolveTemplate,
    buildSrcset: utils.buildSrcset,

    /**
     * Get image data using a SmugMug image ID
     * @param  {String} id
     * @return {Promise}
     */
    get (id) {
      return new Promise((resolve, reject) => {
        axios.get(`/${process.env.SMUGMUG_ROOT}/images/${id}.json`)
          .then(response => {
            resolve(response.data)
          })
          .catch(reject)
      })
    },

    /**
     * Get album data using a SmugMug album ID
     * @param  {String} id
     * @return {Promise}
     */
    getAlbum (id) {
      return new Promise((resolve, reject) => {
        axios.get(`/${process.env.SMUGMUG_ROOT}/albums/${id}.json`)
          .then(response => {
            resolve(response.data)
          })
          .catch(reject)
      })
    },

    /**
     * Asynchronously load the search index
     * @return {Promise}
     */
    async loadSearchIndex () {
      return await import('app/.generated/smugmug/search.json')
    },

    /**
     * Get buffered image data
     * @param  {String}  url
     * @return {Promise}
     */
    async getBuffer (url) {
      return await axios.get(url, { responseType: 'arraybuffer' })
    }
  }
}



// WEBPACK FOOTER //
// ./app/src/plugins/smugmug.js